import axios from "axios";
import store from "../redux-store/store";
import { logoutUser } from "redux-store/auth/actions";
import { handleUnAuthorizedAction } from "redux-store/auth/reducers";
import { NON_TENANT_SUBDOMAINS } from "config/tenancy";

function getSubdomain() {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  // Assuming your main domain has two parts (e.g., example.com)
  // Adjust the number `2` if your main domain is different (e.g., example.co.uk would need `3`)
  if (parts.length > 2) {
    return parts[0];
  }
  return null;
}

export const setAxios = () => {
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
  axios.defaults.headers.common["Content-Type"] = "application/json";

  const hostSubdomain = getSubdomain();
  // "energy" (this app's own host) is a product label, not a tenant — never
  // send it as the tenant header. See NON_TENANT_SUBDOMAINS in src/api/index.js.
  let subdomain = NON_TENANT_SUBDOMAINS.has(hostSubdomain) ? null : hostSubdomain;

  if (localStorage._subdomain && (!hostSubdomain || NON_TENANT_SUBDOMAINS.has(hostSubdomain))) {
    subdomain = localStorage._subdomain;
  }

  if (subdomain) {
    axios.defaults.headers.common["_subdomain"] = subdomain;
  }

  axios.interceptors.request.use(
    (config) => {
      if (localStorage.authToken) config.headers.Authorization = `Bearer ${localStorage.authToken}`;
      if (localStorage._subdomain && (!hostSubdomain || NON_TENANT_SUBDOMAINS.has(hostSubdomain))) {
        config.headers._subdomain = `${localStorage._subdomain}`;
      } else if (hostSubdomain && !NON_TENANT_SUBDOMAINS.has(hostSubdomain)) {
        config.headers._subdomain = `${hostSubdomain}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (result) => {
      return result;
    },
    (error) => {
      // console.log("===========> store", store.getState()?.auth?.isLoggedIn);
      // console.log("===========> axios result error", error);
      if (error?.response?.status === 401) {
        localStorage?.clear();
        store.dispatch(logoutUser());
        store.dispatch(handleUnAuthorizedAction(true));
      }
      return Promise.reject(error);
    }
  );
};
